import styled from 'styled-components';

export const Layout = styled.div`
  display: grid;
  height: 100vh;
  grid-template-rows: 50px 1fr 1.5fr 3fr 1fr 2fr;
  grid-template-columns: 50px 1fr 3fr;
  grid-template-areas:
    'snav tbar tbar'
    'snav product product'
    'snav details lotNumber'
    'snav details askingBid'
    'snav details status'
    'snav details comments';
  grid-gap: 5px;
  overflow-y: scroll;
  & > div:not(:first-child) {
    border: 1px solid gray;
  }
  & .blockStatus {
    & h2 {
      font-size: min(2vw, 3em);
    }
  }
`;

export default Layout;
